import { CircuitCreateStepperStockType } from "../circuitCreateStepper";

export const getCreateStockVariables = (stock_type: CircuitCreateStepperStockType): { use_stock: boolean; use_product_stock: boolean; } => {
    switch (stock_type) {
        case CircuitCreateStepperStockType.STOCK_ON_THE_PACKAGE:
            return { use_stock: true, use_product_stock: false };
        case CircuitCreateStepperStockType.STOCK_ON_THE_PRODUCT:
            return { use_stock: false, use_product_stock: true };
        case CircuitCreateStepperStockType.STOCK_ON_THE_PRODUCT_AND_PACKAGE:
            return { use_stock: true, use_product_stock: true };
        default:
            return { use_stock: false, use_product_stock: false };

    }
};

export const createSettepperSotckType = (data: { use_stock: boolean; use_product_stock: boolean }): CircuitCreateStepperStockType => {
    if (data.use_stock && !data.use_product_stock) return CircuitCreateStepperStockType.STOCK_ON_THE_PACKAGE;
    if (!data.use_stock && data.use_product_stock) return CircuitCreateStepperStockType.STOCK_ON_THE_PRODUCT;
    if (data.use_stock && data.use_product_stock) return CircuitCreateStepperStockType.STOCK_ON_THE_PRODUCT_AND_PACKAGE;
    return CircuitCreateStepperStockType.PACKAGE_WITHOUT_STOCK;
};